import { createAction, createSlice, nanoid } from '@reduxjs/toolkit';

export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

// Action Creators

export const createSnack = createAction('snackbar/createSnack', snack => {
  return {
    payload: {
      ...snack,
      key: snack?.options?.key ?? nanoid(),
      options: {
        ...(snack?.options ?? {}),
        persist: snack?.options?.persist ?? snack?.options?.variant === 'error',
        variant: snack?.options?.variant,
      },
    },
  };
});

export const closeSnack = createAction('snackbar/closeSnack', key => ({
  payload: { dismissAll: !key, key },
}));

// Reducers

const reducers = {
  removeSnack: (state, action) => ({
    ...state,
    list: state.list.filter(snack => snack.key !== action.payload),
  }),
};

const extraReducers = {
  [closeSnack]: (state, action) => ({
    ...state,
    list: state.list.map(snack =>
      action.payload.dismissAll || snack.key === action.payload.key
        ? { ...snack, dismissed: true }
        : { ...snack }
    ),
  }),
  [createSnack]: (state, action) => ({
    ...state,
    list: [
      ...state.list,
      {
        key: action.payload.key,
        ...action.payload,
      },
    ],
  }),
};

// Slice

const { actions, reducer } = createSlice({
  extraReducers,
  initialState: { list: [] },
  name: 'snackbar',
  reducers,
});

export const { removeSnack } = actions;

export default reducer;
